import { defineComponent as _defineComponent } from 'vue'
import ContrlPanl from '@/components/control-panl/index.vue'
import { ctrolGroup, CtrlAtom } from './constant'
import { computed, ref, shallowRef, watch, watchEffect } from 'vue'
import Confirm from '@kankan/components/src/components/dialog/Confirm.vue'
import { TemploraryID } from '@/store'
import { Message } from '@kankan/components/src/expose-common'
import { Model } from '@/request'
import {
  filePropress,
  list as ylist,
  uploadList,
  getSureAttachDatasets
} from '@/store/dataset'
import { ui18n } from '@/lang'
import { genUseLoading } from '@/hook'


export default /*#__PURE__*/_defineComponent({
  __name: 'control',
  emits: ["upload", "select"],
  setup(__props, { expose: __expose, emit }) {

const list = computed(() => ylist.value.concat(uploadList.value))


const init = ref(false)
const options = ref<Model.SureDatasets>([])
const exixtsData = ref(false)
const title = ref('')
const pageNum = ref(0)
const updateNextOptions = genUseLoading(async () => {
  const data = (
    await getSureAttachDatasets(title.value, pageNum.value + 1)
  ).filter(item => !options.value.some(ia => ia.sceneCode === item.sceneCode))
  if (!exixtsData.value) {
    exixtsData.value = data.length > 0
  }
  if (selectDataset.value) {
    const ndx = data.findIndex(
      item => item.datasetId === selectDataset.value.datasetId
    )
    if (~ndx) {
      data[ndx] = selectDataset.value
    }
  }
  options.value.push(...data)
  if (data.length > 0) {
    pageNum.value++
  }
  init.value = true
})
const refre = async () => {
  pageNum.value = 0
  options.value = []
  await updateNextOptions()
}
watch(title, refre, { flush: 'sync' })

const selectDataset = ref<Model.SureDataset>()
const selectOptions = computed(() =>
  options.value.map(atom => ({
    label: atom.name || atom.sceneCode || 'unname',
    value: atom
  }))
)
const selectRef = ref()
const selectHandler = (raw: { label: string; value: Model.SureDataset }) => {
  selectDataset.value = raw.value
  setTimeout(() => {
    selectRef.value.vmRef.vmRef.vmRef.input.blur()
  }, 100)
}

watchEffect(onCleanup => {
  if (!selectRef.value) {
    return
  }
  const dom = (
    selectRef.value.vmRef.vmRef.floating.vmRef as HTMLDivElement
  ).querySelector('.select-replace')

  let loading = false
  const stopWatch = watch(title, () => (loading = false))
  const scrollHandler = async (ev: Event) => {
    if (loading) return
    if (dom.scrollTop + dom.clientHeight >= dom.scrollHeight - 80) {
      loading = true
      let curPageNum = pageNum.value
      await updateNextOptions()
      if (curPageNum !== pageNum.value) {
        loading = false
      }
    }
  }
  dom.addEventListener('scroll', scrollHandler)
  onCleanup(() => {
    dom.removeEventListener('scroll', scrollHandler)
    stopWatch()
  })
})

const show = ref(false)
const clickHandler = (text: 'ok' | 'no') => {
  show.value = false
  if (text === 'ok') {
    emit('select', selectDataset.value)
  }
  selectDataset.value = null
}

const fileRef = ref()
const file = ref()
const uploadHandler = (file: File) => {
  if (!/^[A-Za-z0-9_\.]+$/.test(file.name)) {
    Message.warning(ui18n.t('dataset.uploadCheck'))
  } else {
    emit('upload', file)
  }
}

const runs = shallowRef<Array<CtrlAtom>>([])
const useSetting = (ctrl: CtrlAtom) => {
  const isUpload = list.value.find(
    atom => TemploraryID.is(atom.id) || atom.jobId
  )
  if (isUpload || filePropress.value) {
    return Message.warning(ui18n.t('resStatus.8004'))
  }

  if (ctrl.value === 'add') {
    if (options.value.length) {
      show.value = true
    } else {
      Message.warning(ui18n.t('dataset.unJoinDatasets'))
    }
  } else {
    fileRef.value.vmRef.input.click()
  }
}

__expose({
  select() {
    refre().then(() => useSetting(ctrolGroup[0].ctrls[0]))
  },
  upload() {
    useSetting(ctrolGroup[1].ctrls[0])
  }
})

const __returned__ = { list, emit, init, options, exixtsData, title, pageNum, updateNextOptions, refre, selectDataset, selectOptions, selectRef, selectHandler, show, clickHandler, fileRef, file, uploadHandler, runs, useSetting, ContrlPanl, get ctrolGroup() { return ctrolGroup }, Confirm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})